import { Controller } from '@hotwired/stimulus';

const SIGNUP_ORIGIN_COOKIE = 'bs_signup_origin';
const COOKIE_NAME = 'bs_oauth_popup';
const CHECKOUT_TARGET_COOKIE = 'bs_signup_checkout_target';
const POPUP_NAME = 'betterSheetsGoogleOAuth';

/** POST OmniAuth to a named popup so the main Better Sheets tab stays put. */
export default class extends Controller {
  static values = {
    popupName: { type: String, default: POPUP_NAME },
    popupWidth: { type: Number, default: 520 },
    popupHeight: { type: Number, default: 640 },
    checkoutTarget: String,
  };

  /** Intercept form submit: set cookie, open centered popup, submit into it. */
  openInPopup(event) {
    const form = event.currentTarget;
    if (!(form instanceof HTMLFormElement)) return;

    event.preventDefault();

    const secure = typeof window !== 'undefined' && window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${COOKIE_NAME}=1; Path=/; Max-Age=600; SameSite=Lax${secure}`;
    document.cookie = `${SIGNUP_ORIGIN_COOKIE}=${encodeURIComponent(window.location.pathname + window.location.search)}; Path=/; Max-Age=600; SameSite=Lax${secure}`;

    if (this.hasCheckoutTargetValue && this.checkoutTargetValue) {
      document.cookie = `${CHECKOUT_TARGET_COOKIE}=${encodeURIComponent(this.checkoutTargetValue)}; Path=/; Max-Age=1800; SameSite=Lax${secure}`;
    }

    const w = this.popupWidthValue;
    const h = this.popupHeightValue;
    const left = Math.round(window.screenX + (window.outerWidth - w) / 2);
    const top = Math.round(window.screenY + (window.outerHeight - h) / 2);
    const features = `popup=yes,width=${w},height=${h},left=${left},top=${top}`;

    const popup = window.open('', this.popupNameValue, features);
    if (!popup || popup.closed) {
      document.cookie = `${COOKIE_NAME}=; Path=/; Max-Age=0${secure}`;
      window.alert('Allow pop-ups for this site to continue with Google without leaving the page.');
      return;
    }

    popup.focus();
    form.target = this.popupNameValue;
    form.submit();
  }
}
